module.exports = __webpack_public_path__ + "static/img/线上续方@3x.ca11562.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/线上续方@3x.png
// module id = 315
// module chunks = 363 364